import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        participation: '=',
        classifiers: '='
    },
    template: `
        <div class="heading01 type01">
            <h1 ng-if="vm.participation.isRequest
                && vm.participation.status !== vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED_BY_DIRECT_MANAGER">{{ 'participation.Training request' | translate }}
                <small>
                    {{ vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS[vm.participation.status] }}
                </small>
            </h1>
            <h1 ng-if="!vm.participation.isRequest
                || vm.participation.status == vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED_BY_DIRECT_MANAGER">{{ 'participation.Passed training' | translate }}
                <small>
                    {{ vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS[vm.participation.status] }}
                </small>
            </h1>
            <ul class="actions01">
                <li ng-if="vm.participation.isSpecificTraining && vm.participation.status !== vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CANCELLED">
                    <a ng-click="vm.editExternal()" class="btn edit">{{ 'general.Edit' | translate }}</a>
                </li>
                <li>
                    <a ui-sref="authorized.courses.participations.list()" class="btn discrete">{{ 'general.Back to list' | translate }}</a>
                </li>
            </ul>
        </div>
        <div class="block05 ng-scope">
            <div class="block05a">
                <div class="block05__heading">
                    <div class="block05__heading-primary">
                        <dl class="meta03">
                            <div>
                                <dt>{{ 'participation.Employee' | translate }}</dt>
                                <dd>{{ vm.participation.user.displayName }}</dd>
                            </div>
                        </dl>
                    </div>
                    <div class="block05__heading-secondary">
                        <dl class="meta03">
                            <div ng-if="vm.participation.duration">
                                <dt>{{ 'training.Duration' | translate }}</dt>
                                <dd>{{ vm.participation.duration }} {{ vm.COURSE_DURATION_TYPE_ENUM.SHORTEN[vm.participation.durationType] }}</dd>
                            </div>
                            <div ng-if="vm.participation.price">
                                <dt>{{ 'courses.external.Cost' | translate }}</dt>
                                <dd>{{ vm.participation.price }} {{ vm.COURSE_PRICE_TYPE_ENUM.LABELS[vm.participation.priceType] }}</dd>
                            </div>
                        </dl>
                    </div>
                </div>
                <dl class="meta03 vertical">
                    <div>
                        <dt>{{ 'participant.Course name' | translate }}</dt>
                        <dd>{{ vm.participation.courseName }}</dd>
                    </div>
                </dl>
            </div>
            <div class="block05b">
                <div class="form readonly" ng-if="vm.participation.isSpecificTraining">
                    <div class="row">
                        <span class="label">{{ 'courses.external.Training type' | translate }}</span>
                        <div class="items">
                            <span class="text">{{ vm.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.LABELS[vm.participation.trainingType] }}</span>
                        </div>
                    </div>
                    <div class="row" ng-if="vm.participation.trainingLink">
                        <span class="label">{{ 'course.Training link' | translate }}</span>
                        <div class="items">
                            <span class="text">
                                <a href="{{ vm.participation.trainingLink }}" target="_blank">{{ vm.participation.trainingLink }}</a>
                            </span>
                        </div>
                    </div>
                    <div class="row" ng-if="vm.participation.courseDates.length">
                        <span class="label">{{ 'courses.external.Training dates' | translate }}</span>
                        <div class="items">
                            <ul class="nobullet">
                                <li ng-repeat="date in vm.participation.courseDates">
                                    {{ vm.MomentService.formatTimeStamp(date.startTime, vm.format, false) }} - {{ vm.MomentService.formatTimeStamp(date.endTime, vm.format, false) }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row" ng-if="vm.participation.fields.length">
                        <span class="label">{{ 'courses.external.Training field' | translate }}</span>
                        <div class="items">
                            <ul class="nobullet">
                                <li ng-repeat="field in vm.participation.fields">
                                    {{ field.field.activeI18n.value }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row" ng-if="vm.participation.trainer">
                        <span class="label">{{ 'participation.Trainer' | translate }}</span>
                        <div class="items"><span class="text">{{ vm.participation.trainer }}</span></div>
                    </div>
                    <div class="row" ng-if="vm.participation.expireDate">
                        <span class="label">{{ 'reports.Expire date' | translate }}</span>
                        <div class="items"><span ng-if="vm.participation.expireDate" class="text">{{ vm.MomentService.formatDate(vm.participation.expireDate) }}</span></div>
                    </div>
                    <div class="row" ng-if="vm.participation.certificateNumber">
                        <span class="label">{{ 'courses.external.participation.Certificate number' | translate }}</span>
                        <div class="items">
                            <span ng-if="vm.participation.certificateNumber" class="text">
                                {{ vm.participation.certificateNumber }}
                            </span>
                        </div>
                    </div>
                    <div class="row" ng-if="vm.participation.additionalInfo">
                        <span class="label">{{ 'courses.external.Additional info' | translate }}</span>
                        <div class="items">
                            <span ng-if="vm.participation.additionalInfo" ng-bind-html="vm.StringService.changeNewLineToBr(vm.participation.additionalInfo)" class="text">
                            </span>
                        </div>
                    </div>
                    <div class="row" ng-if="vm.participation.files.length">
                        <span class="label">{{ 'courses.external.Files' | translate }}</span>
                        <div class="items">
                            <ul>
                                <li ng-repeat="file in vm.participation.files">
                                    <a ng-click="vm.download(file.id)">{{ file.originalName }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row" ng-if="vm.getCommentFromDm()">
                        <span class="label">{{ 'course.external.Direct manager comment' | translate }}</span>
                        <div class="items">
                            <span ng-bind-html="vm.StringService.changeNewLineToBr(vm.getCommentFromDm())" class="text">
                            </span>
                        </div>
                    </div>
                </div>
                <div class="form readonly" ng-if="!vm.participation.isSpecificTraining">
                    <div class="row row-wide">
                        <span class="label">{{ 'courses.external.Content of request' | translate }}</span>
                        <div class="items">
                            <span ng-if="vm.participation.requestContent" ng-bind-html="vm.StringService.changeNewLineToBr(vm.participation.requestContent)" class="text">
                            </span>
                        </div>
                    </div>
                    <div class="row row-wide" ng-if="vm.participation.requestMotivation">
                        <span class="label">{{ 'courses.external.How would your motivation change after the training' | translate }}</span>
                        <div class="items">
                            <span ng-if="vm.participation.requestMotivation" ng-bind-html="vm.StringService.changeNewLineToBr(vm.participation.requestMotivation)" class="text">
                            </span>
                        </div>
                    </div>
                    <div class="row row-wide" ng-if="vm.participation.requestTrainingPreference">
                        <span class="label">{{ 'courses.external.How much do you want the training?' | translate }}</span>
                        <div class="items">
                            <span ng-if="vm.participation.requestTrainingPreference" ng-bind-html="vm.StringService.changeNewLineToBr(vm.getTrainingPreference())" class="text">
                            </span>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li class="primary" ng-if="vm.participation.status !== vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED
                        && vm.participation.status !== vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CANCELLED">
                        <a ng-click="vm.approveParticipation()" class="btn main">{{ 'participation.Approve' | translate }}</a>
                    </li>
                    <li class="primary" ng-if="vm.participation.status !== vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.DECLINED
                        && vm.participation.status !== vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CANCELLED">
                        <a ng-click="vm.declineParticipation()" class="btn negative">{{ 'participation.Decline' | translate }}</a>
                    </li>
                    <li class="primary" ng-if="vm.participation.status === vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.DECLINED">
                        <a ng-click="vm.deleteParticipation()" class="btn negative">{{ 'general.Delete' | translate }}</a>
                    </li>
                    <li ng-if="vm.participation.editor" class="primary text">
                        <small>
                            {{ 'general.Last changed by' | translate }}: {{ vm.participation.editor.displayName }}, {{ vm.MomentService.formatTimeStamp(vm.participation.updatedAt) }}<br>
                            <a ng-if="vm.PrivilegeService.isCompanyAdmin()" ui-sref="authorized.manage.logs.auditlog">{{ 'courses.external.Additional info' | translate }}</a>
                        </small>
                    </li>
                </ul>
            </div>
        </div>
    `
})
export default class {
    constructor ($window, $state, $translate, toastr, lodash, StringService, MomentService, FormFactory, AuthResource,
                 COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM, ModalService, ExternalParticipationResource, PrivilegeService,
                 COURSE_DURATION_TYPE_ENUM, COURSE_PRICE_TYPE_ENUM, COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM) {
        this.$window = $window;
        this.$state = $state;
        this.$translate = $translate;
        this.toastr = toastr;
        this.lodash = lodash;
        this.StringService = StringService;
        this.MomentService = MomentService;
        this.FormFactory = FormFactory;
        this.AuthResource = AuthResource;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.ExternalParticipationResource = ExternalParticipationResource;
        this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM = COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM;
        this.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM = COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM;
        this.COURSE_DURATION_TYPE_ENUM = COURSE_DURATION_TYPE_ENUM;
        this.COURSE_PRICE_TYPE_ENUM = COURSE_PRICE_TYPE_ENUM;

        this.format = 'DD-MM-YYYY HH:mm:ss';
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.participation);
        this.formatCourseDates();
    }

    getTrainingPreference () {
        return this.$translate.instant(`courses.external.${this.participation.requestTrainingPreference}`);
    }

    getCommentFromDm () {
        const comments = this.getComments();
        if (this.participation.status === this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED_BY_DIRECT_MANAGER) {
            return comments.approved;
        }
        if (this.participation.status === this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.NEED_DETAILS) {
            return comments.needDetails;
        }
        if (this.participation.status === this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.DECLINED) {
            return comments.declined;
        }
        return null;
    }

    getComments () {
        const comments = {
            approved: null,
            declined: null,
            needDetails: null
        };
        this.lodash.forEach(this.participation.comments, comment => {
            if (comment.type === 'APPROVED') {
                comments.approved = comment.text;
            }
            if (comment.type === 'DECLINED') {
                comments.declined = comment.text;
            }
            if (comment.type === 'NEED_DETAILS') {
                comments.needDetails = comment.text;
            }
        });
        return comments;
    }

    formatCourseDates () {
        const format = 'YYYY-MM-DD HH:mm:ss';

        this.form.model.courseDates.forEach((date) => {
            date.startTime = this.MomentService.formatTimeStamp(date.startTime, format, true);
            date.endTime = this.MomentService.formatTimeStamp(date.endTime, format, true);
        });
    }

    updateParticipation () {
        const expand = 'user,files,editor,courseDates,fields.field.activeI18n';
        this.ExternalParticipationResource.get({ id: this.participation.id, expand }).$promise
        .then((participation) => {
            this.participation = participation;
            this.$onInit();
        });
    }

    editExternal () {
        const { participation, classifiers } = this;

        return this.ModalService.open({
            template: `
                <modals-courses-external-edit-participation
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    participation="vm.participation"
                    classifiers="vm.classifiers"
                />
            `,
            size: 'xlarge',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.participation = participation;
                this.classifiers = classifiers;
            }
        }).then(() => {
            this.updateParticipation();
        });
    }

    setParticipationStatus (status) {
        this.form.model.status = status;
        this.form.model.isAdminRequest = true;
        this.form.save().then((model) => {
            if (this.form.model.status === this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED) {
                this.toastr.success(
                    this.$translate.instant('participation.Employee { displayName } external participation of course { courseName } successfully confirmed', {
                        displayName: this.participation.user.displayName,
                        courseName: this.participation.courseName
                    })
                );
            }
            else if (this.form.model.status === this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.DECLINED) {
                this.toastr.success(
                    this.$translate.instant(
                        'participation.Employee { displayName } external participation of course { courseName } successfully declined. Employee has been notified via e-mail about the declination',
                        {
                            displayName: this.participation.user.displayName,
                            courseName: this.participation.courseName
                        })
                );
            }

            this.participation.status = model.status;
            this.updateParticipation();
            this.$onInit();
        })
            .catch((response) => this.lodash.forEach(response.data, data => this.toastr.error(data.message)));
    }

    download (id) {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const url = `${SEED_CORE.ENV.API_URL}course/external-participation/file-download?tacToken=${token}&id=${id}`;
                this.$window.open(url);
            });
    }

    deleteParticipation () {
        const confirmMessage = this.$translate.instant('courses.external.Action can not be undone. Are you sure you wish to delete the external participation?');
        this.ModalService.confirm(confirmMessage, 'medium').then(() => {
            this.ExternalParticipationResource.delete({ id: this.participation.id }).$promise.then(() => {
                this.$state.go('authorized.courses.participations.list');
            });
        });
    }

    approveParticipation () {
        const confirmStatus = this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED;

        if (this.form.model.status === this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.WAITING_FOR_DIRECT_MANAGER) {
            const confirmMessage = this.$translate.instant('courses.external.Are you sure you wish to perform the action instead of the direct manager?');
            this.ModalService.confirm(confirmMessage, 'medium').then(() => {
                this.setParticipationStatus(confirmStatus);
            });
        }
        else {
            this.setParticipationStatus(confirmStatus);
        }
    }

    declineParticipation () {
        const declineStatus = this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.DECLINED;

        if (this.form.model.status === this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.WAITING_FOR_DIRECT_MANAGER) {
            const confirmMessage = this.$translate.instant('courses.external.Are you sure you wish to perform the action instead of the direct manager?');
            this.ModalService.confirm(confirmMessage, 'medium').then(() => {
                this.setParticipationStatus(declineStatus);
            });
        }
        else {
            this.setParticipationStatus(declineStatus);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/participations/detail/index.js